function videoIsLoaded(video: HTMLVideoElement) {
  return video.readyState === 4;
}

export function videoLoadElement(video: HTMLVideoElement) {
  return new Promise(resolve => {
    if (videoIsLoaded(video)) {
      resolve();
    } else {
      video.addEventListener("error", resolve);
      video.addEventListener("canplay", () => {
        if (videoIsLoaded(video)) {
          resolve();
        }
      });
    }
  });
}

export function videoLoad(src: string) {
  const video = document.createElement("video");
  const source = document.createElement("source");
  source.src = src;
  source.type = "video/mp4";
  video.appendChild(source);
  return videoLoadElement(video);
}

function imageIsLoaded(image: HTMLImageElement) {
  return Boolean(image.complete && image.naturalWidth);
}

export function imageLoad(src: string, srcset?: string) {
  const image = new Image();
  if (srcset && typeof image.srcset !== "undefined") {
    image.srcset = srcset;
  } else {
    image.src = src;
  }
  return imageLoadElement(image);
}

export function imageLoadElement(image: HTMLImageElement) {
  return new Promise(resolve => {
    if (imageIsLoaded(image)) {
      resolve();
    } else {
      image.addEventListener("load", () => {
        if (imageIsLoaded(image)) {
          resolve();
        }
      });
    }
  });
}
